exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".icon-root-1Y5 {\n    --stroke: rgb(var(--venia-text));\n    align-items: center;\n    display: inline-flex;\n    justify-content: center;\n    touch-action: manipulation;\n}\n\n.icon-icon-3z4 {\n    fill: var(--fill, none);\n    stroke: var(--stroke);\n}\n", ""]);

// Exports
exports.locals = {
	"root": "icon-root-1Y5",
	"icon": "icon-icon-3z4"
};